import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Modal } from 'containers/misc'
import { ConfirmBox, Button, ButtonGroup } from 'components/misc'

import { Table, Data } from 'components/layout/Table'
import { apiKeys as apiKeysLayout } from 'constants/layout'
import { modal } from 'redux/modules/app'
import { FormattedTime } from 'react-intl'
import { FormattedDate } from 'components/intl'

const enhance = compose(withRouter, connect(null, { modal }))

class ApiKeyList extends Component {
  static propTypes = {
    apiKeys: PropTypes.array.isRequired,
    modal: PropTypes.func.isRequired,
    deleteApiKey: PropTypes.func.isRequired,
    handleRefresh: PropTypes.func.isRequired
  };

  static defaultProps = {
    apiKeys: []
  };

  state = {
    apiKeyIdToDelete: undefined
  };

  handleCloseModal = () => this.props.modal(null);

  handleShowModal = id => {
    this.setState({ apiKeyIdToDelete: id })
    this.props.modal('modal-delete-api-key')
  };

  handleDelete = async () => {
    if (this.state.apiKeyIdToDelete) {
      await this.props.deleteApiKey(this.state.apiKeyIdToDelete)
      this.props.handleRefresh()
    }
    this.props.modal(null)
    this.setState({ apiKeyIdToDelete: undefined })
  }

  render () {
    const {
      apiKeys
    } = this.props

    return (
      <div>
        <div className="base-margin--top">
          <Table
            ths={apiKeysLayout.tableHeaders}
            length={apiKeys.length}
          >
            <Data>
              {apiKeys.map(({
                              id,
                              apiKey,
                              lastUsed
                            }) => (
                <tr key={apiKey}>
                  <td>
                    {apiKey}
                  </td>
                  <td>
                    {lastUsed && <FormattedDate timeZone="UTC" value={lastUsed} spaceAfter />}
                    {lastUsed && ' '}
                    {lastUsed && <FormattedTime timeZone="UTC" value={lastUsed} />}
                    {!lastUsed && '-'}
                  </td>
                  <td width="150">
                    <ButtonGroup>
                      <Button
                        onClick={() => {
                          this.handleShowModal(id)
                        }}
                        secondary
                        tiny
                        negative
                        type="button"
                        intlKey="button.delete"
                      >
                        Delete
                      </Button>
                    </ButtonGroup>
                  </td>
                </tr>
              ))}
            </Data>
          </Table>
        </div>
        <Modal id="modal-delete-api-key" customActions>
          <ConfirmBox
            onSecondaryClick={this.handleCloseModal}
            onClick={this.handleDelete}
            title="Are you sure?"
            titleIntlKey="moduleTitle.are_you_sure"
          />
        </Modal>
      </div>
    )
  }
}

export default enhance(ApiKeyList)
